export interface Chapter {
  id: string;
  title: string;
}

export interface Comic {
  id: string;
  title: string;
  status: string;
  author: string;
  category: string;
  tags: string[];
  cover: string;
  description: string;
  rating: number;
  views: string;
  favorite: string;
  updateDate: string;
  totalChapters: number;
  lastChapter: string;
  featured?: boolean;
  chapters: Chapter[];
  panels?: string[];
}

export const featuredComicId = "zlczha";

export const comics: Comic[] = [
  {
    id: "zlczha",
    title: "再来一次好吗",
    status: "连载中",
    author: "白夜工作室",
    category: "lianai",
    tags: ["纯爱", "青春", "治愈", "校园"],
    cover: "https://readdy.ai/api/search-image?query=Warm%20romantic%20anime%20manga%20cover%20illustration%20of%20a%20young%20couple%20under%20cherry%20blossom%20trees%20at%20golden%20sunset%2C%20soft%20pastel%20tones%2C%20gentle%20eye%20contact%2C%20dreamy%20light%20flares%2C%20clean%20simple%20background%2C%20editorial%20webtoon%20style%2C%20high%20detail&width=480&height=640&seq=comic-zlczha-cover&orientation=portrait",
    description: "如果时间可以重来，我会在遇见你的那一刻，鼓起勇气说「再来一次好吗」。苏晚与林知夏的故事，从一场青涩的相遇开始，跨越青春的遗憾与成长的治愈之旅。每一次错过，都是为重逢埋下的伏笔。",
    rating: 9.7,
    views: "3.2亿",
    favorite: "128万",
    updateDate: "今天",
    totalChapters: 186,
    lastChapter: "第186话 再一次",
    featured: true,
    chapters: [
      { id: "c186", title: "第186话 再一次" },
      { id: "c185", title: "第185话 迟到的告白" },
      { id: "c184", title: "第184话 雨中相拥" },
      { id: "c183", title: "第183话 重来的意义" },
      { id: "c182", title: "第182话 命运的玩笑" },
      { id: "c181", title: "第181话 心跳加速" },
      { id: "c180", title: "第180话 夏夜的星空" },
      { id: "c179", title: "第179话 误会解开" },
      { id: "c178", title: "第178话 第一次约会" },
      { id: "c177", title: "第177话 转校生" },
    ],
    panels: [
      "https://readdy.ai/api/search-image?query=Webtoon%20comic%20panel%20scene%20of%20a%20young%20couple%20meeting%20on%20a%20school%20corridor%2C%20warm%20morning%20light%20through%20windows%2C%20soft%20colors%2C%20clean%20lineart%2C%20anime%20style%2C%20expressive%20faces&width=540&height=900&seq=panel-01&orientation=portrait",
      "https://readdy.ai/api/search-image?query=Webtoon%20comic%20panel%20of%20girl%20looking%20away%20blushing%2C%20cherry%20blossom%20petals%20falling%2C%20gentle%20breeze%2C%20warm%20pastel%20palette%2C%20clean%20anime%20illustration%2C%20soft%20shading&width=540&height=900&seq=panel-02&orientation=portrait",
      "https://readdy.ai/api/search-image?query=Webtoon%20comic%20panel%20of%20boy%20and%20girl%20walking%20home%20together%20under%20street%20lights%20at%20dusk%2C%20warm%20golden%20tones%2C%20anime%20background%2C%20silhouette%2C%20romantic%20atmosphere&width=540&height=900&seq=panel-03&orientation=portrait",
      "https://readdy.ai/api/search-image?query=Webtoon%20comic%20panel%20close%20up%20of%20hands%20almost%20touching%2C%20nervous%20moment%2C%20soft%20focus%20blossoms%20background%2C%20romantic%20light%2C%20clean%20anime%20style&width=540&height=900&seq=panel-04&orientation=portrait",
      "https://readdy.ai/api/search-image?query=Webtoon%20comic%20panel%20of%20rainy%20scene%20two%20characters%20sharing%20one%20umbrella%2C%20blue%20grey%20rain%20but%20warm%20light%20glow%20around%20them%2C%20emotional%2C%20clean%20anime%20illustration&width=540&height=900&seq=panel-05&orientation=portrait",
      "https://readdy.ai/api/search-image?query=Webtoon%20comic%20panel%20of%20couple%20under%20starry%20night%20sky%20on%20rooftop%2C%20city%20lights%20below%2C%20warm%20and%20dreamy%2C%20anime%20style%2C%20soft%20glow%2C%20romantic&width=540&height=900&seq=panel-06&orientation=portrait",
      "https://readdy.ai/api/search-image?query=Webtoon%20comic%20panel%20of%20girl%20smiling%20brightly%20while%20waving%20goodbye%2C%20sunset%20backlight%2C%20cherry%20blossom%20trees%2C%20happy%20warm%20tone%2C%20clean%20anime%20lineart&width=540&height=900&seq=panel-07&orientation=portrait",
      "https://readdy.ai/api/search-image?query=Webtoon%20comic%20panel%20wide%20shot%20of%20young%20couple%20holding%20hands%20in%20a%20field%20of%20sunflowers%20at%20golden%20hour%2C%20hopeful%20ending%20feeling%2C%20warm%20colors%2C%20anime%20style&width=540&height=900&seq=panel-08&orientation=portrait",
    ],
  },
  {
    id: "xiari",
    title: "夏日的约定",
    status: "已完结",
    author: "青空漫绘",
    category: "xiaoyuan",
    tags: ["校园", "友情", "青春"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20school%20friends%20at%20summer%20seaside%2C%20blue%20sky%20ocean%20background%2C%20warm%20sunlight%2C%20youthful%20and%20bright%2C%20clean%20simple%20composition%2C%20editorial%20webtoon%20style%2C%20high%20detail&width=480&height=640&seq=comic-xiari-cover&orientation=portrait",
    description: "一个关于夏天的约定，一段不会褪色的青春记忆。六位少年少女在毕业前的最后一个夏天，许下了一起去看海的约定。多年之后，他们能否兑现彼此说过的话？",
    rating: 9.2,
    views: "1.8亿",
    favorite: "76万",
    updateDate: "昨天",
    totalChapters: 96,
    lastChapter: "第96话 那个夏天",
    chapters: [
      { id: "c96", title: "第96话 那个夏天" },
      { id: "c95", title: "第95话 海边的烟火" },
      { id: "c94", title: "第94话 约定兑现" },
      { id: "c93", title: "第93话 回家的路" },
      { id: "c92", title: "第92话 沙滩排球" },
    ],
  },
  {
    id: "yuexia",
    title: "月下魔法学院",
    status: "连载中",
    author: "星尘画社",
    category: "qihuan",
    tags: ["魔法", "学院", "冒险"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20young%20mage%20with%20glowing%20spell%20under%20giant%20moon%2C%20fantasy%20academy%20castle%20background%2C%20mystical%20purple%20and%20gold%2C%20clean%20composition%2C%20webtoon%20style%2C%20high%20detail&width=480&height=640&seq=comic-yuexia-cover&orientation=portrait",
    description: "在月圆之夜，天赋异禀的少女洛月进入传说中的魔法学院。然而她发现，这所学校隐藏着一个关于月亮的古老秘密。在这里，每一次施法都可能改变整个世界的命运。",
    rating: 9.4,
    views: "2.4亿",
    favorite: "98万",
    updateDate: "3天前",
    totalChapters: 142,
    lastChapter: "第142话 月之试炼",
    chapters: [
      { id: "c142", title: "第142话 月之试炼" },
      { id: "c141", title: "第141话 禁咒的秘密" },
      { id: "c140", title: "第140话 魔王的预兆" },
      { id: "c139", title: "第139话 星光对决" },
      { id: "c138", title: "第138话 新生报到" },
    ],
  },
  {
    id: "dushi",
    title: "都市心计",
    status: "连载中",
    author: "墨染文化",
    category: "dushi",
    tags: ["职场", "都市", "情感"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20elegant%20business%20woman%20in%20city%20skyline%20at%20dusk%2C%20modern%20glass%20buildings%2C%20warm%20city%20lights%2C%20sophisticated%20style%2C%20clean%20composition%2C%20webtoon%20style%2C%20high%20detail&width=480&height=640&seq=comic-dushi-cover&orientation=portrait",
    description: "在繁华的都市里，每个人都在戴着面具生活。职场新人与老练对手之间的博弈，爱情与利益的抉择，人心叵测，究竟谁才是最后的赢家？",
    rating: 8.9,
    views: "1.2亿",
    favorite: "45万",
    updateDate: "5天前",
    totalChapters: 118,
    lastChapter: "第118话 摊牌",
    chapters: [
      { id: "c118", title: "第118话 摊牌" },
      { id: "c117", title: "第117话 幕后黑手" },
      { id: "c116", title: "第116话 最后一战" },
      { id: "c115", title: "第115话 背叛" },
      { id: "c114", title: "第114话 局中局" },
    ],
  },
  {
    id: "poxiao",
    title: "破晓少年团",
    status: "连载中",
    author: "烈火动漫",
    category: "rexue",
    tags: ["热血", "战斗", "少年"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20brave%20boy%20team%20facing%20a%20huge%20dragon%2C%20fiery%20orange%20sky%2C%20epic%20battle%20scene%2C%20dynamic%20pose%2C%20clean%20composition%2C%20webtoon%20style%2C%20high%20detail&width=480&height=640&seq=comic-poxiao-cover&orientation=portrait",
    description: "当世界陷入黑暗，一群怀揣梦想的少年挺身而出。为了守护家园，他们踏上破晓的征途。友情、羁绊与永不放弃的热血，少年们终将迎来属于自己的黎明。",
    rating: 9.5,
    views: "3.8亿",
    favorite: "156万",
    updateDate: "今天",
    totalChapters: 224,
    lastChapter: "第224话 破晓",
    chapters: [
      { id: "c224", title: "第224话 破晓" },
      { id: "c223", title: "第223话 觉醒" },
      { id: "c222", title: "第222话 最后一击" },
      { id: "c221", title: "第221话 并肩作战" },
      { id: "c220", title: "第220话 新的敌人" },
    ],
  },
  {
    id: "miwu",
    title: "迷雾档案",
    status: "连载中",
    author: "暗夜推理社",
    category: "xuanyi",
    tags: ["悬疑", "推理", "犯罪"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20detective%20silhouette%20in%20foggy%20night%20alleyway%2C%20moody%20dark%20teal%20and%20amber%20lighting%2C%20mysterious%20atmosphere%2C%20clean%20composition%2C%20webtoon%20style%2C%20high%20detail&width=480&height=640&seq=comic-miwu-cover&orientation=portrait",
    description: "一座迷雾笼罩的城市，一桩桩离奇悬案。天才刑警与神秘女法医联手，在重重迷雾中追寻真相。每一次推理的翻转，都让真相更加扑朔迷离。",
    rating: 9.3,
    views: "2.1亿",
    favorite: "88万",
    updateDate: "2天前",
    totalChapters: 168,
    lastChapter: "第168话 迷雾散去",
    chapters: [
      { id: "c168", title: "第168话 迷雾散去" },
      { id: "c167", title: "第167话 真相大白" },
      { id: "c166", title: "第166话 最终推理" },
      { id: "c165", title: "第165话 关键证据" },
      { id: "c164", title: "第164话 反转" },
    ],
  },
  {
    id: "xindong",
    title: "心动信号",
    status: "连载中",
    author: "拾光漫绘",
    category: "lianai",
    tags: ["纯爱", "都市", "治愈"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20couple%20with%20phones%20showing%20heart%20notifications%2C%20warm%20cafe%20background%2C%20soft%20pink%20and%20cream%20tones%2C%20clean%20composition%2C%20webtoon%20style%2C%20high%20detail&width=480&height=640&seq=comic-xindong-cover&orientation=portrait",
    description: "当缘分的信号悄悄响起，两个素不相识的灵魂开始相互靠近。在都市的灯火里，一场关于心动的故事悄然展开。爱情，往往就藏在不经意的瞬间。",
    rating: 9.0,
    views: "9800万",
    favorite: "39万",
    updateDate: "1周前",
    totalChapters: 78,
    lastChapter: "第78话 信号满格",
    chapters: [
      { id: "c78", title: "第78话 信号满格" },
      { id: "c77", title: "第77话 靠近" },
      { id: "c76", title: "第76话 心动预警" },
      { id: "c75", title: "第75话 巧合还是缘分" },
    ],
  },
  {
    id: "tongzhuo",
    title: "同桌的你",
    status: "已完结",
    author: "纸间物语",
    category: "xiaoyuan",
    tags: ["校园", "青春", "成长"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20deskmates%20in%20a%20sunlit%20classroom%2C%20books%20and%20chalkboard%2C%20warm%20afternoon%20light%2C%20youthful%20nostalgia%2C%20clean%20composition%2C%20webtoon%20style%2C%20high%20detail&width=480&height=640&seq=comic-tongzhuo-cover&orientation=portrait",
    description: "一个班级里，一张课桌旁，两个看似毫无交集的同学。从最初的针锋相对，到后来的默契无间，青春里的那些小确幸，都藏在了同桌的日常里。",
    rating: 9.1,
    views: "1.5亿",
    favorite: "63万",
    updateDate: "上个月",
    totalChapters: 88,
    lastChapter: "第88话 毕业快乐",
    chapters: [
      { id: "c88", title: "第88话 毕业快乐" },
      { id: "c87", title: "第87话 最后的同桌" },
      { id: "c86", title: "第86话 那些年" },
      { id: "c85", title: "第85话 换座位" },
    ],
  },
  {
    id: "xinghai",
    title: "星海旅人",
    status: "连载中",
    author: "星际画师",
    category: "qihuan",
    tags: ["科幻", "冒险", "奇幻"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20astronaut%20in%20nebulous%20space%20with%20glowing%20star%20rivers%2C%20deep%20cosmic%20colors%2C%20epic%20scale%2C%20clean%20composition%2C%20webtoon%20style%2C%20high%20detail&width=480&height=640&seq=comic-xinghai-cover&orientation=portrait",
    description: "宇宙的尽头是什么？一位孤独的星海旅人驾驶着飞船穿越无数星系，寻找故乡的坐标。在星辰大海之间，他遇见了各种各样的生命，也明白了回家的意义。",
    rating: 9.4,
    views: "2.0亿",
    favorite: "82万",
    updateDate: "4天前",
    totalChapters: 132,
    lastChapter: "第132话 星海彼岸",
    chapters: [
      { id: "c132", title: "第132话 星海彼岸" },
      { id: "c131", title: "第131话 引力场" },
      { id: "c130", title: "第130话 黑洞边缘" },
      { id: "c129", title: "第129话 新家园" },
    ],
  },
  {
    id: "jiaban",
    title: "加班惊魂",
    status: "连载中",
    author: "深夜放映室",
    category: "dushi",
    tags: ["都市", "职场", "喜剧"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20tired%20office%20worker%20at%20desk%20at%20night%20with%20laptop%20glow%2C%20funny%20exaggerated%20expression%2C%20warm%20desk%20lamp%20light%2C%20comedy%20style%2C%20clean%20composition%2C%20webtoon%20style%2C%20high%20detail&width=480&height=640&seq=comic-jiaban-cover&orientation=portrait",
    description: "打工人每天都在上演的惊悚片。加班到深夜的社畜们，在办公室里的奇遇与笑料百出。一本属于每一个熬夜加班的你我的爆笑职场漫画。",
    rating: 8.8,
    views: "8600万",
    favorite: "31万",
    updateDate: "6天前",
    totalChapters: 66,
    lastChapter: "第66话 周五不加班",
    chapters: [
      { id: "c66", title: "第66话 周五不加班" },
      { id: "c65", title: "第65话 摸鱼大师" },
      { id: "c64", title: "第64话 咖啡续命" },
      { id: "c63", title: "第63话 深夜食堂" },
    ],
  },
  {
    id: "jixian",
    title: "极限冲刺",
    status: "已完结",
    author: "疾风动漫",
    category: "rexue",
    tags: ["体育", "热血", "竞技"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20sprinter%20mid%20stride%20on%20red%20running%20track%2C%20motion%20blur%2C%20fiery%20energy%2C%20stadium%20background%2C%20dynamic%20composition%2C%20webtoon%20style%2C%20high%20detail&width=480&height=640&seq=comic-jixian-cover&orientation=portrait",
    description: "百米赛道上，0.01秒的差距就是天堂与地狱。天赋异禀的少年天才，在一次次极限冲刺中突破自我，向世界纪录发起挑战。热血与汗水交织的青春竞技物语。",
    rating: 9.3,
    views: "1.9亿",
    favorite: "74万",
    updateDate: "上个月",
    totalChapters: 104,
    lastChapter: "第104话 冠军之巅",
    chapters: [
      { id: "c104", title: "第104话 冠军之巅" },
      { id: "c103", title: "第103话 终点线" },
      { id: "c102", title: "第102话 全力奔跑" },
      { id: "c101", title: "第101话 新纪录" },
    ],
  },
  {
    id: "diqi",
    title: "第七个房间",
    status: "连载中",
    author: "迷雾推理社",
    category: "xuanyi",
    tags: ["悬疑", "心理", "密室"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20mysterious%20door%20with%20number%20seven%20glowing%20in%20dark%20corridor%2C%20moody%20dramatic%20lighting%2C%20suspense%20atmosphere%2C%20clean%20composition%2C%20webtoon%20style%2C%20high%20detail&width=480&height=640&seq=comic-diqi-cover&orientation=portrait",
    description: "一座古宅里隐藏着七间密室，每一间都通往不同的过去。误入其中的少女必须解开每一扇门后的谜题，才能找到回家的出口。而第七个房间，藏着最惊人的秘密。",
    rating: 9.2,
    views: "1.3亿",
    favorite: "52万",
    updateDate: "3天前",
    totalChapters: 92,
    lastChapter: "第92话 第七扇门",
    chapters: [
      { id: "c92", title: "第92话 第七扇门" },
      { id: "c91", title: "第91话 钥匙" },
      { id: "c90", title: "第90话 谜底" },
      { id: "c89", title: "第89话 通道" },
    ],
  },
  {
    id: "yinghua",
    title: "樱花之约",
    status: "连载中",
    author: "春日漫社",
    category: "lianai",
    tags: ["纯爱", "治愈", "恋爱"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20couple%20under%20falling%20cherry%20blossom%20petals%2C%20soft%20pink%20dreamy%20background%2C%20tender%20romantic%20moment%2C%20clean%20composition%2C%20webtoon%20style%2C%20high%20detail&width=480&height=640&seq=comic-yinghua-cover&orientation=portrait",
    description: "每年春天，樱花盛开的时候，他们都会在樱花树下重逢。一场跨越十年的约定，一段被时间温柔以待的爱情。有些约定，值得用一生去守护。",
    rating: 9.6,
    views: "2.7亿",
    favorite: "112万",
    updateDate: "今天",
    totalChapters: 156,
    lastChapter: "第156话 樱花树下",
    chapters: [
      { id: "c156", title: "第156话 樱花树下" },
      { id: "c155", title: "第155话 花开花落" },
      { id: "c154", title: "第154话 十年之约" },
      { id: "c153", title: "第153话 重逢" },
      { id: "c152", title: "第152话 初春" },
    ],
  },
  {
    id: "shetuan",
    title: "社团风云",
    status: "已完结",
    author: "漫笔生花",
    category: "xiaoyuan",
    tags: ["校园", "搞笑", "社团"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20hilarious%20school%20club%20members%20in%20comic%20poses%2C%20colorful%20club%20room%2C%20fun%20energetic%20style%2C%20bright%20background%2C%20clean%20composition%2C%20webtoon%20style%2C%20high%20detail&width=480&height=640&seq=comic-shetuan-cover&orientation=portrait",
    description: "一个濒临解散的社团，一群性格迥异的奇葩社员。为了保住社团，他们闹出了一连串让人捧腹大笑的乌龙事件。校园生活的快乐，就藏在这些鸡飞狗跳里。",
    rating: 8.9,
    views: "9900万",
    favorite: "40万",
    updateDate: "上个月",
    totalChapters: 72,
    lastChapter: "第72话 最佳社团",
    chapters: [
      { id: "c72", title: "第72话 最佳社团" },
      { id: "c71", title: "第71话 招新大战" },
      { id: "c70", title: "第70话 活动筹备" },
      { id: "c69", title: "第69话 社团危机" },
    ],
  },
  {
    id: "longyu",
    title: "龙语者",
    status: "连载中",
    author: "苍穹漫绘",
    category: "qihuan",
    tags: ["奇幻", "冒险", "龙"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20girl%20communicating%20with%20a%20gentle%20dragon%2C%20misty%20mountain%20valley%20background%2C%20golden%20light%2C%20epic%20and%20warm%2C%20clean%20composition%2C%20webtoon%20style%2C%20high%20detail&width=480&height=640&seq=comic-longyu-cover&orientation=portrait",
    description: "世间早已没有龙的时代，少女却意外获得了听懂龙语的能力。她踏上寻找远古巨龙之路，也在旅途中逐渐发现，人与龙之间的羁绊从未真正断绝。",
    rating: 9.3,
    views: "1.7亿",
    favorite: "68万",
    updateDate: "5天前",
    totalChapters: 121,
    lastChapter: "第121话 龙之谷",
    chapters: [
      { id: "c121", title: "第121话 龙之谷" },
      { id: "c120", title: "第120话 龙吟" },
      { id: "c119", title: "第119话 远古遗迹" },
      { id: "c118", title: "第118话 龙语传承" },
    ],
  },
  {
    id: "shenye",
    title: "深夜食堂物语",
    status: "连载中",
    author: "人间烟火社",
    category: "dushi",
    tags: ["美食", "治愈", "都市"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20warm%20steaming%20bowl%20of%20noodles%20on%20a%20small%20counter%20at%20night%2C%20cozy%20lantern%20glow%2C%20food%20comic%20style%2C%20warm%20inviting%20atmosphere%2C%20clean%20composition%2C%20webtoon%20style%2C%20high%20detail&width=480&height=640&seq=comic-shenye-cover&orientation=portrait",
    description: "深夜零点，城市里唯一亮着灯的食堂开始营业。每个疲惫的灵魂，都能在这里用一碗热腾腾的食物，换走一天的心事。这里贩卖的不仅是美食，更是温暖。",
    rating: 9.2,
    views: "1.4亿",
    favorite: "57万",
    updateDate: "昨天",
    totalChapters: 109,
    lastChapter: "第109话 治愈的汤",
    chapters: [
      { id: "c109", title: "第109话 治愈的汤" },
      { id: "c108", title: "第108话 深夜来客" },
      { id: "c107", title: "第107话 家的味道" },
      { id: "c106", title: "第106话 加一碗面" },
    ],
  },
  {
    id: "lieyan",
    title: "烈焰拳手",
    status: "连载中",
    author: "热血工作室",
    category: "rexue",
    tags: ["格斗", "热血", "成长"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20boxer%20with%20flames%20around%20fists%20in%20ring%2C%20dramatic%20arena%20lights%2C%20fiery%20orange%20red%2C%20powerful%20pose%2C%20clean%20composition%2C%20webtoon%20style%2C%20high%20detail&width=480&height=640&seq=comic-lieyan-cover&orientation=portrait",
    description: "从街头少年到擂台之王，他的拳头里燃烧着不服输的火焰。为了守护重要的人，他踏上拳击之路，在一次次的倒下与站起中，寻找真正的强大。",
    rating: 9.4,
    views: "2.2亿",
    favorite: "91万",
    updateDate: "2天前",
    totalChapters: 148,
    lastChapter: "第148话 火焰之拳",
    chapters: [
      { id: "c148", title: "第148话 火焰之拳" },
      { id: "c147", title: "第147话 重拳出击" },
      { id: "c146", title: "第146话 冠军对决" },
      { id: "c145", title: "第145话 迎战" },
    ],
  },
  {
    id: "wusheng",
    title: "无声证词",
    status: "已完结",
    author: "冷案档案",
    category: "xuanyi",
    tags: ["悬疑", "犯罪", "破案"],
    cover: "https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20of%20crime%20scene%20evidence%20board%20with%20photos%20and%20strings%2C%20dark%20moody%20detective%20room%2C%20amber%20and%20grey%20tones%2C%20mysterious%2C%20clean%20composition%2C%20webtoon%20style%2C%20high%20detail&width=480&height=640&seq=comic-wusheng-cover&orientation=portrait",
    description: "证人无法开口，真相藏于无声。法医笔下的每一份证词，都在为沉默的逝者说话。一桩陈年悬案，在一位坚持真相的刑警手中，逐渐浮现出骇人的轮廓。",
    rating: 9.3,
    views: "1.6亿",
    favorite: "65万",
    updateDate: "2个月前",
    totalChapters: 84,
    lastChapter: "第84话 结案",
    chapters: [
      { id: "c84", title: "第84话 结案" },
      { id: "c83", title: "第83话 真相" },
      { id: "c82", title: "第82话 关键物证" },
      { id: "c81", title: "第81话 重启调查" },
    ],
  },
];

export const getComicById = (id: string) => comics.find((c) => c.id === id);

// 通用阅读面板：供没有独立分镜的漫画在阅读时使用
export const defaultReadingPanels: string[] = [
  "https://readdy.ai/api/search-image?query=Webtoon%20comic%20panel%20wide%20establishing%20shot%20of%20a%20serene%20city%20at%20dusk%2C%20warm%20golden%20light%2C%20clean%20anime%20background%20art%2C%20soft%20atmosphere%2C%20high%20detail&width=540&height=900&seq=default-panel-01&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Webtoon%20comic%20panel%20of%20a%20young%20person%20walking%20through%20a%20busy%20street%2C%20expressive%20anime%20character%2C%20warm%20sunlight%2C%20clean%20lineart%2C%20soft%20shading&width=540&height=900&seq=default-panel-02&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Webtoon%20comic%20panel%20close%20up%20of%20two%20characters%20in%20conversation%2C%20emotional%20moment%2C%20soft%20bokeh%20background%2C%20clean%20anime%20style%2C%20warm%20tones&width=540&height=900&seq=default-panel-03&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Webtoon%20comic%20panel%20of%20a%20character%20looking%20up%20at%20a%20bright%20sky%2C%20hopeful%20expression%2C%20light%20flares%2C%20clean%20anime%20illustration%2C%20dreamy%20atmosphere&width=540&height=900&seq=default-panel-04&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Webtoon%20comic%20panel%20wide%20shot%20of%20friends%20gathering%20together%2C%20group%20silhouette%20against%20sunset%2C%20warm%20and%20cozy%2C%20clean%20anime%20style%2C%20heartwarming&width=540&height=900&seq=default-panel-05&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Webtoon%20comic%20panel%20of%20a%20gentle%20rain%20scene%20with%20reflections%20on%20the%20ground%2C%20moody%20yet%20warm%20lighting%2C%20clean%20anime%20art%2C%20atmospheric%20detail&width=540&height=900&seq=default-panel-06&orientation=portrait",
];